<template>
  <div class="loader">
    <img src="assets/loader_animhead.gif" alt="">
    <div class="square"></div>
  </div>
</template>

<script>

import 'hooper/dist/hooper.css';


export default {
  name: 'Loader',
  data() {
    return {}
  },
  methods: {},
  mounted() {
  }
}

</script>

<style>
.loader {
  display: none;
  width: 100vw;
  position: absolute;
  z-index: 1;
  top: 0;
  left: 0;
  height: 100%;
  justify-content: center;
  align-content: center;
  background: rgba(10, 10, 10, 0.35);
}

.loader img {
  border-radius: 50%;
  width: 30%;
  margin: auto;
  border: 2px solid var(--main-color);
}
</style>
